/**
 * 對話框外殼與表單欄位（設計系統正式化前的輕量實作）。
 *
 * `onBackdropClick` 為選填是刻意的：不可誤關的對話框（例如只顯示一次的機密）
 * 直接不傳，背景點擊就不會生效。同理 Esc 由呼叫端自行決定是否掛。
 */

import { useEffect, type ReactNode } from 'react';

export function ModalShell({
  children,
  width,
  onBackdropClick,
}: {
  children: ReactNode;
  width: number;
  onBackdropClick?: (() => void) | undefined;
}): JSX.Element {
  return (
    <div
      onClick={onBackdropClick}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: 8,
          padding: 24,
          width,
          maxWidth: '92vw',
          maxHeight: '88vh',
          overflow: 'auto',
        }}
      >
        {children}
      </div>
    </div>
  );
}

/** Esc 關閉；`enabled=false` 時停用（例如送出中不該被關掉）。 */
export function useEscapeToClose(onClose: () => void, enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, enabled]);
}

export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>{label}</label>
      {hint && <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>{hint}</div>}
      {children}
    </div>
  );
}

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 10px',
  fontSize: 14,
  border: '1px solid #d1d5db',
  borderRadius: 6,
  marginTop: 4,
};

export const errorTextStyle: React.CSSProperties = {
  fontSize: 11,
  color: '#b91c1c',
  marginTop: 4,
};
